const INBOUND_TYPES = new Set(['ANRUF', 'WEITERLEITUNG']);
const OUTBOUND_TYPES = new Set(['AUSGEHEND', 'OUTBOUND']);

/**
 * Maps a call-note `type` to the direction the feedback API stores. Anything
 * else (callbacks, test calls, unknown or missing types) is `null`, so such a
 * call still sends feedback.
 *
 * @ticket QAS-6936
 */
export function callDirectionOf(
  type: string | null | undefined,
): 'inbound' | 'outbound' | null {
  const t = type?.toUpperCase();
  if (!t) return null;
  if (INBOUND_TYPES.has(t)) return 'inbound';
  if (OUTBOUND_TYPES.has(t)) return 'outbound';
  return null;
}
